import { render, staticRenderFns } from "./avatar-group.vue?vue&type=template&id=1b219bde&scoped=true&"
import script from "./avatar-group.vue?vue&type=script&lang=ts&"
export * from "./avatar-group.vue?vue&type=script&lang=ts&"
import style0 from "./avatar-group.vue?vue&type=style&index=0&id=1b219bde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b219bde",
  null
  
)

export default component.exports